import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Cell } from "~@/api";

type CodeStatus = 1001 | 1002 | 1003 | 1004 | 1005 | 1006 | 1007 | 1008;

interface InventoryUploadState {
  errorMessage?: string;
  codeStatus?: CodeStatus;
  cells?: Cell[];
}

const initialState: InventoryUploadState = {
  errorMessage: undefined,
  codeStatus: undefined,
  cells: undefined,
};

const inventoryUploadSlice = createSlice({
  name: "inventoryUpload",
  initialState,
  reducers: {
    setErrorMessage(state, action: PayloadAction<string | undefined>) {
      state.errorMessage = action.payload;
    },
    setCodeStatus(state, action: PayloadAction<CodeStatus | undefined>) {
      state.codeStatus = action.payload;
    },
    setCells(state, action: PayloadAction<Cell[] | undefined>) {
      state.cells = action.payload;
    },
    clearInventoryUpload(state) {
      state.errorMessage = undefined;
      state.codeStatus = undefined;
      state.cells = undefined;
    },
  },
});

export const {
  setErrorMessage,
  setCodeStatus,
  setCells,
  clearInventoryUpload,
} = inventoryUploadSlice.actions;

export default inventoryUploadSlice.reducer;
